import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import COLORS from "scss/colors.module.scss";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
    width: "100%",
  },
  box: {
    padding: 0,
    margin: 0,
    fontSize: 13,
    fontWeight: "normal",
  },
}));

export default function GroupColumns(props) {
  const classes = useStyles();

  const changeColumn = (event) => {
    props.changeColumn(event.currentTarget);
  };
  const changeGroupOptions = (event) => {
    props.changeGroupOptions(event.currentTarget);
  };

  const deleteColumn = () => {
    props.deleteColumn();
  };

  return (
    <div className={classes.root}>
      <Box className={classes.box} display="flex" p={1} alignItems="center">
        <Box p={1} className={classes.box} style={{ paddingleft: 10 }}>
          <IconButton aria-label="close" onClick={deleteColumn}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box p={1} className={classes.box}>
          {props.title}
        </Box>
        <Box
          p={1}
          flexGrow={1}
          display="flex"
          flexDirection="row-reverse"
          className={classes.box}
          style={{ paddingInlineEnd: 10 }}
        >
          <Button
            style={{ fontSize: 14, fontWeight: "normal" }}
            endIcon={<ArrowDropDownIcon />}
            onClick={changeColumn}
            style={{ fontSize: 13, fontWeight: 400 }}
          >
            {props.column.label}
          </Button>
        </Box>
        {props.column?.rowGroupOption?.length > 0 && (
          <>
            <Box p={1} className={classes.box}>
              {"as:"}
            </Box>
            <Box
              p={1}
              flexGrow={1}
              display="flex"
              flexDirection="row-reverse"
              className={classes.box}
              style={{ paddingInlineEnd: 10 }}
            >
              <Button
                style={{ fontSize: 14, fontWeight: "normal" }}
                endIcon={<ArrowDropDownIcon />}
                onClick={changeGroupOptions}
                style={{ fontSize: 13, fontWeight: 400 }}
              >
                {props.column.rowGroupOption}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </div>
  );
}
